<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Safes transfers')"
          :description="$t('From here you can control safes transfers')"
        />
        <indexTable
          :searchText="$t('Search for transfer')"
          :emptyTableText="$t('There are no withdrawals operations')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('safes_transfers_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Operation'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'from_safe_id',
              title: $t('From safe transfers'),
              element: 'fromSafe',
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'to_safe_id',
              title: $t('To safe transfers'),
              element: 'toSafe',
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('Transfer date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Amount'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('safes_transfers_edit')
                },
                { name: 'file' },
                { name: 'printSafesTransfer', role: true },
                {
                  name: 'delete',
                  role: $checkRole('safes_transfers_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/safesTransfers'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
